import { THEMES } from "../core/themes";
import { themeManager } from "../core/theme";

export function initThemePanel(): void {
  const overlay = document.getElementById("theme-overlay")!;
  const modal = document.getElementById("theme-modal")!;
  const themeBtn = document.getElementById("theme-btn") as HTMLButtonElement;

  function closeOverlay(): void {
    overlay.classList.add("hidden");
  }

  themeBtn.addEventListener("click", () => {
    overlay.classList.remove("hidden");
    render();
  });
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeOverlay();
  });

  function buildSwatchGrid(title: string): HTMLElement {
    const section = document.createElement("div");
    section.className = "theme-section";
    const heading = document.createElement("h3");
    heading.textContent = title;
    section.appendChild(heading);

    const grid = document.createElement("div");
    grid.className = "theme-grid";
    section.appendChild(grid);
    return section;
  }

  function render(): void {
    modal.innerHTML = "";

    const header = document.createElement("div");
    header.className = "settings-header";
    const title = document.createElement("h2");
    title.textContent = "Theme";
    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "close-button";
    closeBtn.textContent = "✕";
    closeBtn.addEventListener("click", () => closeOverlay());
    header.append(title, closeBtn);
    modal.appendChild(header);

    const colorHint = document.createElement("p");
    colorHint.className = "theme-color-hint";
    colorHint.textContent =
      "(If you want to change your player color after joining a lobby, click on your circle in the player list.)";
    modal.appendChild(colorHint);

    const currentTheme = themeManager.current;
    const darkSection = buildSwatchGrid("Dark themes");
    const lightSection = buildSwatchGrid("Light themes");
    const darkGrid = darkSection.querySelector(".theme-grid")!;
    const lightGrid = lightSection.querySelector(".theme-grid")!;

    for (const theme of THEMES) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "theme-swatch";
      if (theme.id === currentTheme) btn.classList.add("active");
      btn.style.background = theme.previewBg;
      btn.style.borderColor = theme.previewAccent;
      btn.title = theme.label;

      const dot = document.createElement("span");
      dot.className = "theme-swatch-dot";
      dot.style.background = theme.previewAccent;
      btn.appendChild(dot);

      const label = document.createElement("span");
      label.className = "theme-swatch-label";
      label.textContent = theme.label;
      label.style.color = theme.previewAccent;
      btn.appendChild(label);

      btn.addEventListener("click", () => {
        themeManager.setTheme(theme.id);
        render();
      });

      (theme.isDark ? darkGrid : lightGrid).appendChild(btn);
    }

    modal.append(darkSection, lightSection);

    const bgToggleRow = document.createElement("label");
    bgToggleRow.className = "theme-bg-toggle";
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = themeManager.backgroundImageEnabled;
    checkbox.addEventListener("change", () => themeManager.setBackgroundImageEnabled(checkbox.checked));
    bgToggleRow.append(checkbox, document.createTextNode(" Show background image"));
    modal.appendChild(bgToggleRow);
  }
}
